// extracted by mini-css-extract-plugin
export default {"container":"Grid__container___MX7Jk"};